import React from 'react';
import { ButtonRounded } from '../UISystem/Buttons/ButtonRounded';
import { SHADOWS } from '../../styles/UISystem';

/**
 * Modal shown when browser notification permission has been denied.
 * Provides device-specific instructions for re-enabling.
 * Follows BrowserPermissionModal's pattern.
 *
 * @param {function} onDismiss - Called when user closes the modal
 */
const NotificationPermissionModal = ({ onDismiss }) => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const getInstructions = () => {
    if (isIOS) {
      return (
        <ol style={{ textAlign: 'left', paddingLeft: '20px' }}>
          <li>Open the Settings app</li>
          <li>Scroll down and tap Safari</li>
          <li>Tap &quot;Notifications&quot;</li>
          <li>Find this website and turn on &quot;Allow Notifications&quot;</li>
        </ol>
      );
    } else if (isAndroid) {
      return (
        <ol style={{ textAlign: 'left', paddingLeft: '20px' }}>
          <li>Tap the three dots (menu) in your browser</li>
          <li>Tap &quot;Settings&quot; → &quot;Site settings&quot;</li>
          <li>Tap &quot;Notifications&quot;</li>
          <li>Find this website and change the permission</li>
        </ol>
      );
    } else if (isSafari) {
      return (
        <ol style={{ textAlign: 'left', paddingLeft: '20px' }}>
          <li>Click Safari in the menu bar</li>
          <li>Click &quot;Settings for This Website&quot;</li>
          <li>Change Notifications permission to &quot;Allow&quot;</li>
        </ol>
      );
    } else {
      return (
        <ol style={{ textAlign: 'left', paddingLeft: '20px' }}>
          <li>Click the lock/info icon in the address bar</li>
          <li>Click &quot;Site settings&quot;</li>
          <li>Change Notifications from &quot;Block&quot; to &quot;Allow&quot;</li>
        </ol>
      );
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          width: '85%',
          maxWidth: '400px',
          boxShadow: SHADOWS.TIER3_UP,
          textAlign: 'center',
        }}
      >
        <h3 style={{ margin: '0 0 15px', color: '#333' }}>Notifications Blocked</h3>

        <p style={{ margin: '0 0 15px', color: '#666', fontSize: '16px' }}>
          Your browser is blocking notifications. To turn them on, update your browser settings:
        </p>

        {getInstructions()}

        <div style={{ marginTop: '20px' }}>
          <ButtonRounded text="Got it" variant="black" size="full" onClick={onDismiss} />
        </div>
      </div>
    </div>
  );
};

export default NotificationPermissionModal;
